import { Site } from "@/types/sites";
import { CompetitionPageTemplate } from "@/types/competitions";
import { getFacebookCookies } from "@/utils/cookies/client";
import { sendBeaconOrFetch } from "@/utils/apiUtils";
import { logNewGoogleAnalyticsEvent } from "@/utils/utils";


export const handleGoodlifeFormSubmit = async (
    site: Site,
    competitionPage: CompetitionPageTemplate,
    formData: Record<string, any>,
    leadId: string | null,
    errorMessage?: string | null
) => {
    const { fbp, fbc } = getFacebookCookies();
    const searchParams = new URLSearchParams(window.location.search);
    const twclid = searchParams.get("twclid");

    const optedIn = (formData["subscribe_email"] == 'on' || formData["subscribe_phone"] == 'on' || formData["subscribe_sms"] == 'on') ? 'on' : '';
    let first_name = "", last_name = "", full_name = "";
    
    if (formData.full_name) {
        full_name = formData.full_name.toString();
        first_name = full_name.split(' ')[0] || "";
        last_name = full_name.split(' ').slice(1).join(' ') || "";
    } else if (formData.first_name || formData.last_name) {
        first_name = formData.first_name || "";
        last_name = formData.last_name || "";
        full_name = `${first_name} ${last_name}`.trim();
    }

    const allData = {
        href: window.location.href,
        site,
        competitionPage,
        userFormData: {
            accept_terms_policy: optedIn,
            email: formData.email?.toString(),
            first_name: first_name,
            last_name: last_name,
            full_name: full_name,
            phone_number: formData.phone_number?.toString(),
            subscribe_email: optedIn,
            subscribe_phone: optedIn,
            subscribe_sms: optedIn,
            provider: 'email'
        },
        goodlifeData:{
            draw_id: competitionPage.draw_id,
            list_id: competitionPage.list_id,
            lead_id: leadId
        },
        offerPageRedirectUrl: competitionPage.offer_page_template_url,
        ckm_request_id: window.ckm_request_id,
        fbp: fbp,
        fbc: fbc,
        twclid: twclid,
        origin: "form",
        vertical: "competitions",
        notes: errorMessage ? `Error: ${errorMessage}` : ""
    };

    logNewGoogleAnalyticsEvent(
        "lead-form-submitted",
        {
            provider:'email',
            email:formData.email?.toString(),
            vertical:"competitions",
        },
    )

    try {
        await sendBeaconOrFetch(
            "/api/form/leadForm",
            allData,
            "leadForm-form"
        );
    } catch (error) {
        console.error(error);
    }
}
